import SiteDto from "../Common/dtos/RegisteredSiteDto";
import { QueryOptions } from "../Common/useQuery";
import useUserQuery from "../Common/useUserQuery";
import { useUser } from "../UserAccess/useUser";

const useGetAdminSites = (options?: QueryOptions<SiteDto[]>) => {
  const user = useUser();

  return useUserQuery<SiteDto[]>(
    { path: `/api/businesses/${user.selectedBusiness?.id!}/sites` },
    options);
}

export default useGetAdminSites;
